<template>
    <!--    the parent route has div row and col-12 specified-->
    <np-skeleton v-if="!isInitialAppDataFetchCompleted" :type="'forms'"></np-skeleton>
    <div v-else>
        <np-application-breadcrumb :crumbs="businessTabsToRender" :mode="'pagecrumb'"></np-application-breadcrumb>
        <router-view></router-view>
    </div>

</template>

<script>

    //TODO bank fields, principal cards CSS, invite/add check box for principal details.
    import {
        NPSkeleton,
    } from "../../../../js/netpify/components";
    import utilMixin from "../../../utils/mixins";
    import applicationMixin from "../../../utils/application-mixin";
    import navigationMixin from "../../../utils/navigation-mixin";
    import NPAppBreadcrumb from "../../../components/np-application-breadcrumb.vue";
    import * as types from "../../../stores/constants";

    export default {
        name: "businessDetailsParent",
        mixins: [utilMixin, applicationMixin, navigationMixin],
        components: {
            'np-application-breadcrumb': NPAppBreadcrumb,
            'np-skeleton': NPSkeleton,
        },
        data() {
            return {
                business_sub_tabs: [
                    // {
                    //     // class: "btn btn-default",
                    //     display: true,
                    //     // icon: "flaticon-cogwheels12",
                    //     is_active: false,
                    //     is_open: false,
                    //     entity_type: 1,
                    //     short_label: "business",
                    //     label: "tab_business_information",
                    //     // lang_key: "tab_business_information",
                    //     tab_id: "tab_business_information",
                    //     url: "",
                    // },
                    {
                        display: true,
                        is_active: true,
                        is_open: false,
                        entity_type: 1,
                        short_label: "business_details",
                        label: "tab_business_details",
                        tab_id: "tab_business_details",
                        url: "",
                    },
                    {
                        display: true,
                        is_active: true,
                        is_open: false,
                        short_label: "trading",
                        label: "trading",
                        tab_id: "tab_outlets",
                        url: "trading/",
                    },
                    {
                        display: true,
                        is_active: true,
                        is_open: false,
                        short_label: "tab_principals",
                        label: "tab_principals",
                        tab_id: "tab_principals",
                        url: "principals/",
                    },
                    //view_principal can handle bank id now
                    // {
                    //     display: false,
                    //     is_active: true,
                    //     is_open: false,
                    //     short_label: "tab_principals",
                    //     label: "tab_principals",
                    //     tab_id: "tab_principals",
                    //     url: "verifyprincipals/",
                    // },
                    // {
                    //     display: true,
                    //     is_active: false,
                    //     is_open: false,
                    //     short_label: "equipment",
                    //     label: "equipment",
                    //     tab_id: "tab_equipment",
                    //     url: "products/",
                    // },{
                    //     display: true,
                    //     is_active: false,
                    //     is_open: false,
                    //     short_label: "pricing",
                    //     label: "pricing",
                    //     tab_id: "tab_pricing",
                    //     url: "products/pricing/",
                    // },
                ],
                // currentRouteId: 0,
                page_label: 'tell_us_more_about_your_business',
            }
        },
        mounted: function () {
            // Init currentRouteId from URL
            // this.refreshCurrentRouteId(this.$router.currentRoute)

            // Handle manual page change
            // this.$router.afterEach((to, from) => {
            //     this.refreshCurrentRouteId(to)
            // })
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.setAppPageTitle(vm.page_label)
                //TODO we might take this to the router.js and make it more robust to hand the different end root_paths and different scenarios

                let is_edit_url_and_not_masked_url = vm.$route.path.includes('/application/edit') && !vm.$route.path.includes('business_details_mask');
                if (vm.isPiiDataMaskedBank && is_edit_url_and_not_masked_url) {
                    vm.$router.push({path: `/application/edit/${vm.$route.params.application_reference}/business_details/business_details_mask/`});
                }
                //if there is no quote and quote is not converted (both will be true when the UI is getting the data from the API)
                //and there is no application reference in the url, redirect back to the quote_root_path
                // if (!vm.objectIsNotEmpty(vm.quote) && !vm.isConvertedQuote && !to.params.application_reference){ //close this route when quote hasn't been converted
                //     vm.$router.push({ path: `${vm.quote_root_path}business/`})
                // }
            } )
        },
        computed: {
            // parameters: function () {
            //     return this.$parent.parameters;
            // },
            businessTabsToRender: function () {
                //let unfinished_application = this.$parent ? (this.$parent.$parent ? this.$parent.$parent.unfinished_application : null ): null;
                let unfinished_application = this.unfinished_application ? this.unfinished_application : null;
                let is_bank_id_verify_configured = this.isMerchantViewAndUpdateDocument(unfinished_application)
                        && this.isBankIdWorkflowConfigured();

                let tabs = this.jsonCopy(this.business_sub_tabs);
                tabs.forEach(obj => {
                    //use outlet_ref or index+1 as :outlet_ref for path
                    // if (obj.tab_id === 'tab_outlets') {
                    //     if (this.objectIsNotEmpty(this.outlets) && this.outlets[0].outlet_external_id !== '') {
                    //         obj.url += this.outlets[0].outlet_external_id
                    //     } else {
                    //         obj.url += '1'; //just hit the first outlets in the array using the index +1 as outlet_ref
                    //     }
                    // }

                    //view_principal can handle bank id now
                    // if (obj.url === 'principals/') {
                    //     obj.display = !is_bank_id_verify_configured;
                    // }
                    // else if (obj.url === 'verifyprincipals/') {
                    //     obj.display = is_bank_id_verify_configured;
                    // }

                    obj.url = this.application_root_path + 'business_details/' + obj.url;
                });

                return tabs;
            },
            outlet: function () {
                return this.outlets[0];
            },
            isFirstPage: function () {
                return this.currentRouteId === 0
            },
            currentRouteId:  function (){
                let currentPath = this.$route;
                let route_id = this.businessTabsToRender.findIndex(route => { return route.url === currentPath.path});
                return route_id !== -1 ? route_id : 0;
            }
        },
        methods: {
            // refreshCurrentRouteId: function (currentPath) {
            //     let route_id = this.businessTabsToRender.findIndex(route => route.url === currentPath.path);
            //     this.currentRouteId = route_id !== -1 ? route_id : 0;
            // },
            // savePage: function () {
            //     this.doApplicationSave();
            // },
            // backPage: function () {
            //     let prev_route = {};
            //     if (this.currentRouteId !== 0) {
            //         prev_route = this.businessTabsToRender[this.currentRouteId - 1];
            //
            //         this.$router.push({path: prev_route.url});
            //     }else{
            //         this.$router.push({path: this.quote_root_path + 'business/pricing/'})
            //     }
            // },
            // nextPage: function () {
            //     //TODO do save and transition
            //     let next_route = {};
            //
            //     if (this.currentRouteId < this.businessTabsToRender.length - 1) {
            //         next_route = this.businessTabsToRender[this.currentRouteId + 1];
            //     } else {
            //         //move to next step.
            //         this.$router.push({path: `${this.application_root_path}documents`});
            //     }
            //     this.$router.push({path: next_route.url})
            // },
        }

    }
</script>

<style scoped>
</style>